export const PRESALE_REQUEST_TYPE_ALIAS = {
  EXISTING_SYSTEM_DEVELOPMENT_COMPLETION: 'EXISTING_SYSTEM_DEVELOPMENT_COMPLETION',
  NEW_CREATION: 'NEW_CREATION',
  MODERNIZATION_OF_OUTDATED: 'MODERNIZATION_OF_OUTDATED',
  EXPANSION_OF_EXISTING_SYSTEM: 'EXPANSION_OF_EXISTING_SYSTEM',
  DEFECT_FIXING: 'DEFECT_FIXING',
  CONTRACT_EXTENSION: 'CONTRACT_EXTENSION',
};

export const PRESALE_REQUEST_TYPE = {
  [PRESALE_REQUEST_TYPE_ALIAS.EXISTING_SYSTEM_DEVELOPMENT_COMPLETION]: 'Existing system development completion',
  [PRESALE_REQUEST_TYPE_ALIAS.NEW_CREATION]: 'New product/system creation',
  [PRESALE_REQUEST_TYPE_ALIAS.MODERNIZATION_OF_OUTDATED]: 'Modernization of outdated system',
  [PRESALE_REQUEST_TYPE_ALIAS.EXPANSION_OF_EXISTING_SYSTEM]: 'Expansion of existing system functionality',
  [PRESALE_REQUEST_TYPE_ALIAS.DEFECT_FIXING]: 'Existing system defects fixing',
  [PRESALE_REQUEST_TYPE_ALIAS.CONTRACT_EXTENSION]: 'Contract extension',
};

export const APPLICATION_TYPE_ALIAS = {
  WEB: 'WEB',
  MOBILE: 'MOBILE',
};

export const APPLICATION_TYPE = {
  [APPLICATION_TYPE_ALIAS.WEB]: 'Web',
  [APPLICATION_TYPE_ALIAS.MOBILE]: 'Mobile',
};

const MOBILE_OS_ALIAS = {
  APPLE: 'APPLE',
  ANDROID: 'ANDROID',
};

export const MOBILE_OS = {
  [MOBILE_OS_ALIAS.APPLE]: 'Apple',
  [MOBILE_OS_ALIAS.ANDROID]: 'Android',
};

export const REQUEST_STATUS = {
  DRAFT: 'DRAFT',
  SUBMITTED: 'SUBMITTED',
  COMPLETED: 'COMPLETED',
};

export const REQUEST_STATUS_ALIAS = {
  [REQUEST_STATUS.DRAFT]: 'Draft',
  [REQUEST_STATUS.SUBMITTED]: 'Processing',
  [REQUEST_STATUS.COMPLETED]: 'Completed',
};
